"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SchemeType;
(function (SchemeType) {
    /**
     * 主站 App
     */
    SchemeType["EzbuyApp"] = "ezbuyapp";
    /**
     * 多国家站 App
     */
    SchemeType["EzbuyInt"] = "ezbuyint";
    /**
     * LightInTheBox
     */
    SchemeType["LITB"] = "litb";
    SchemeType["EECHIC"] = "eechicapp";
})(SchemeType = exports.SchemeType || (exports.SchemeType = {}));
